import _regeneratorRuntime from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { mapGetters } from 'vuex';
// import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
import LangSelect from '@/components/LangSelect';
// import Search from '@/components/HeaderSearch'

export default {
  name: 'NavbarComponent',
  components: {
    // Breadcrumb,
    Hamburger: Hamburger,
    ErrorLog: ErrorLog,
    Screenfull: Screenfull,
    SizeSelect: SizeSelect,
    LangSelect: LangSelect
    // ,
    // Search
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'avatar', 'name', 'device'])),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('user/logout');
            case 2:
              _this.$router.push("/login?redirect=".concat(_this.$route.fullPath));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};